import {BaseEntity,Column,Entity,Index,JoinColumn,JoinTable,ManyToMany,ManyToOne,OneToMany,OneToOne,PrimaryColumn,PrimaryGeneratedColumn,RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn} from "typeorm";
import { Attendance } from "../attendance/attendance.entity";
import {EmployeeDetails} from '../employee-details/employee-details.entity';
@Entity('cost_centers')
export class CostCenters {
  @PrimaryGeneratedColumn("increment",{name:'cost_center_id'})
  costCenterId:number;
  @Column("char",{
    nullable:false,
    length:5,
    name:"cost_center_code"
    })
  @Index({unique:true})
  costCenterCode:string;
  @Column("varchar",{
    nullable:false,
    length:50,
    name:"cost_center_name"
    })
  costCenterName:string;

  @Column("boolean",{
    nullable:false,
    default:true,
    name:"status"
    })
  status:boolean;
  @CreateDateColumn({
    name: "created_at",
    type:"datetime"
  })
  createdAt: Date;

  @Column("int", {
      nullable: false,
      name: "created_user"
  })
  createdUser: number | null;


  @UpdateDateColumn({
      name: "updated_at",
      type:'datetime'
  })
  updatedAt: Date;

  @Column("int", {
      nullable: true,
      name: "updated_user"
  })
  updatedUser: number | null;


  @VersionColumn({
      default:1,
      name: "version_flag"
  })
  versionFlag: number;
  @OneToOne(() => EmployeeDetails, employeeDetails => employeeDetails.Id) 
  // specify inverse side as a second parameter
  @JoinColumn()
  employeeDetails: EmployeeDetails;
  @OneToMany(type => Attendance, attendance=>attendance.costCenterId)
  costCenters: CostCenters[];

}